// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}
iframe
{
    display: none;
}
@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}
.px-6{ padding-left:32px!important;padding-right:32px!important;}
.bk900{ 
background-repeat:no-repeat;
background-position:ceneter;
background-size:cover;
}
.ani-md{width:48px!important; height:48px; }
.ani-sm{width:32px!important; height:32px; }
.ani-xsm{width:22px!important; height:22px; }
.text-shadow{text-shadow: 0px 1px 1px #000000;}
.blocker {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  content: ' ';
  background: rgba(0,0,0,.5);
  z-index: 999999;
}
.react-calendar { 
  width: 500px;
  max-width: 100%;
  background-color: #fff;
  color: #222;
  border-radius: 8px;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
  font-family: Arial, Helvetica, sans-serif;
  line-height: 1.125em;
 }
 .react-calendar__navigation button {
  color: #6f48eb;
  min-width: 44px;
  background: none;
  font-size: 16px;
  margin-top: 8px;
 }
 .react-calendar__navigation button:enabled:hover,
 .react-calendar__navigation button:enabled:focus {
  background-color: #f8f8fa;
 }
 .react-calendar__navigation button[disabled] {
  background-color: #f0f0f0;
 }
 abbr[title] {
  text-decoration: none;
 }
 /* .react-calendar__month-view__days__day--weekend {
  color: #d10000;
 } */
 .react-calendar__tile:enabled:hover,
 .react-calendar__tile:enabled:focus {
  background: #f8f8fa;
  color: #6f48eb;
  border-radius: 6px;
 }
 .react-calendar__tile--now {
  background: #6f48eb33;
  border-radius: 6px;
  font-weight: bold;
  color: #6f48eb;
 }
 .react-calendar__tile--now:enabled:hover,
 .react-calendar__tile--now:enabled:focus {
  background: #6f48eb33;
  border-radius: 6px;
  font-weight: bold;
  color: #6f48eb;
 }
 .react-calendar__tile--hasActive:enabled:hover,
 .react-calendar__tile--hasActive:enabled:focus {
  background: #f8f8fa;
 }
 .react-calendar__tile--active {
  background: #6f48eb;
  border-radius: 6px;
  font-weight: bold;
  color: white;
 }
 .react-calendar__tile--active:enabled:hover,
 .react-calendar__tile--active:enabled:focus {
  background: #6f48eb;
  color: white;
 }
 .react-calendar--selectRange .react-calendar__tile--hover {
  background-color: #f8f8fa;
 }
 .react-calendar__tile--range {
  background: #f8f8fa;
  color: #6f48eb;
  border-radius: 0;
 }
 .react-calendar__tile--rangeStart {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  background: #6f48eb;
  color: white;
 }
 .react-calendar__tile--rangeEnd {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  background: #6f48eb;
  color: white;
 }

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;AACA;;IAEI,aAAa;AACjB;AACA;EACE;IACE,4CAA4C;EAC9C;AACF;AACA,OAAO,2BAA2B,CAAC,4BAA4B,CAAC;AAChE;AACA,2BAA2B;AAC3B,2BAA2B;AAC3B,qBAAqB;AACrB;AACA,QAAQ,oBAAoB,EAAE,WAAW,EAAE;AAC3C,QAAQ,oBAAoB,EAAE,WAAW,EAAE;AAC3C,SAAS,oBAAoB,EAAE,WAAW,EAAE;AAC5C,aAAa,gCAAgC,CAAC;AAC9C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,0CAA0C;EAC1C,yCAAyC;EACzC,oBAAoB;CACrB;CACA;EACC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,eAAe;CAChB;CACA;;EAEC,yBAAyB;CAC1B;CACA;EACC,yBAAyB;CAC1B;CACA;EACC,qBAAqB;CACtB;CACA;;IAEG;CACH;;EAEC,mBAAmB;EACnB,cAAc;EACd,kBAAkB;CACnB;CACA;EACC,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;CACf;CACA;;EAEC,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;CACf;CACA;;EAEC,mBAAmB;CACpB;CACA;EACC,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;CACb;CACA;;EAEC,mBAAmB;EACnB,YAAY;CACb;CACA;EACC,yBAAyB;CAC1B;CACA;EACC,mBAAmB;EACnB,cAAc;EACd,gBAAgB;CACjB;CACA;EACC,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;CACb;CACA;EACC,yBAAyB;EACzB,4BAA4B;EAC5B,4BAA4B;EAC5B,+BAA+B;EAC/B,mBAAmB;EACnB,YAAY;CACb","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\niframe\n{\n    display: none;\n}\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n.px-6{ padding-left:32px!important;padding-right:32px!important;}\n.bk900{ \nbackground-repeat:no-repeat;\nbackground-position:ceneter;\nbackground-size:cover;\n}\n.ani-md{width:48px!important; height:48px; }\n.ani-sm{width:32px!important; height:32px; }\n.ani-xsm{width:22px!important; height:22px; }\n.text-shadow{text-shadow: 0px 1px 1px #000000;}\n.blocker {\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  content: ' ';\n  background: rgba(0,0,0,.5);\n  z-index: 999999;\n}\n.react-calendar { \n  width: 500px;\n  max-width: 100%;\n  background-color: #fff;\n  color: #222;\n  border-radius: 8px;\n  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);\n  font-family: Arial, Helvetica, sans-serif;\n  line-height: 1.125em;\n }\n .react-calendar__navigation button {\n  color: #6f48eb;\n  min-width: 44px;\n  background: none;\n  font-size: 16px;\n  margin-top: 8px;\n }\n .react-calendar__navigation button:enabled:hover,\n .react-calendar__navigation button:enabled:focus {\n  background-color: #f8f8fa;\n }\n .react-calendar__navigation button[disabled] {\n  background-color: #f0f0f0;\n }\n abbr[title] {\n  text-decoration: none;\n }\n /* .react-calendar__month-view__days__day--weekend {\n  color: #d10000;\n } */\n .react-calendar__tile:enabled:hover,\n .react-calendar__tile:enabled:focus {\n  background: #f8f8fa;\n  color: #6f48eb;\n  border-radius: 6px;\n }\n .react-calendar__tile--now {\n  background: #6f48eb33;\n  border-radius: 6px;\n  font-weight: bold;\n  color: #6f48eb;\n }\n .react-calendar__tile--now:enabled:hover,\n .react-calendar__tile--now:enabled:focus {\n  background: #6f48eb33;\n  border-radius: 6px;\n  font-weight: bold;\n  color: #6f48eb;\n }\n .react-calendar__tile--hasActive:enabled:hover,\n .react-calendar__tile--hasActive:enabled:focus {\n  background: #f8f8fa;\n }\n .react-calendar__tile--active {\n  background: #6f48eb;\n  border-radius: 6px;\n  font-weight: bold;\n  color: white;\n }\n .react-calendar__tile--active:enabled:hover,\n .react-calendar__tile--active:enabled:focus {\n  background: #6f48eb;\n  color: white;\n }\n .react-calendar--selectRange .react-calendar__tile--hover {\n  background-color: #f8f8fa;\n }\n .react-calendar__tile--range {\n  background: #f8f8fa;\n  color: #6f48eb;\n  border-radius: 0;\n }\n .react-calendar__tile--rangeStart {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  border-top-left-radius: 6px;\n  border-bottom-left-radius: 6px;\n  background: #6f48eb;\n  color: white;\n }\n .react-calendar__tile--rangeEnd {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n  background: #6f48eb;\n  color: white;\n }\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
